import { render } from "./CourseWeeksSelector.vue?vue&type=template&id=c2e792aa"
import script from "./CourseWeeksSelector.vue?vue&type=script&lang=js"
export * from "./CourseWeeksSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__